import { render, staticRenderFns } from "./incomeStatement.vue?vue&type=template&id=28511d34&"
import script from "./incomeStatement.vue?vue&type=script&lang=js&"
export * from "./incomeStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports